export default __webpack_public_path__ + "static/media/logo.789826ef.JPG";